export const SET_CART = "SET_CART";
export const GET_CART = "GET_CART";
export const SET_CONTACT_ID = "SET_CONTACT_ID";
export const GET_CONTACT_ID = "GET_CONTACT_ID";
